(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-events"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      root.querySelectorAll('[data-laj-ev-car]').forEach(function (car) {
        if (car.dataset.lajEvReady) return;
        car.dataset.lajEvReady = '1';
        var track = car.querySelector('[data-laj-ev-track]');
        var nav = car.querySelector('[data-laj-ev-nav]');
        if (!track || !nav) return;
        var prev = nav.querySelector('[data-d="-1"]');
        var next = nav.querySelector('[data-d="1"]');
        function update() {
          var overflow = track.scrollWidth - track.clientWidth > 2;
          nav.hidden = !overflow;
          prev.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        }
        nav.addEventListener('click', function (e) {
          var b = e.target.closest('button');
          if (!b) return;
          track.scrollBy({ left: track.clientWidth * 0.9 * Number(b.dataset.d) });
        });
        track.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
      });
    }
    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
